// extracted by mini-css-extract-plugin
export default {"modalForm":"Form--modalForm--2e7c93"};